import { render } from "./ScreenQuestionOptionsBP.vue?vue&type=template&id=3155ff8c&scoped=true&ts=true"
import script from "./ScreenQuestionOptionsBP.vue?vue&type=script&lang=ts"
export * from "./ScreenQuestionOptionsBP.vue?vue&type=script&lang=ts"

import "./ScreenQuestionOptionsBP.vue?vue&type=style&index=0&id=3155ff8c&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3155ff8c"]])

export default __exports__